import { Bar } from '../index.js'
import { reactiveProp } from '../util/mixins.js'

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    barOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    options() {
      const defaults = {
        responsive: true,
        maintainAspectRatio: false,
      }

      return Object.assign(defaults, this.barOptions)
    },
  },
  mounted() {
    // this.chartData создаётся внутри миксина.
    // Если вы хотите передать опции, создайте локальный объект options
    this.renderChart(this.chartData, this.options)
  },
}
